// Según manual de marca
const primary = "#22619d";
const secondaryDark = "#232c61";
const secondaryLight = "#2f9fee";
const complementaryLight = "#5eb7e5";
const complementaryLightGray = "#404041";
const complementaryDarkGray = "#efefef";

export const debMediaTheme = {
    palette: {
        primary: {
            main: primary,
        },
        secondary: {
            main: secondaryLight,
            dark: secondaryDark,
        },
        neutral: {
            main: complementaryDarkGray,
            dark: complementaryLightGray
        },
        background: {
            main: "#ff0000",
        },
        grey:{
            light: complementaryDarkGray,
            main: complementaryLightGray,
            dark: "#424242"
        },
        neutral2 : {
            light: complementaryDarkGray,
            main: complementaryLightGray,
            dark: "#222222",
            contrastText: "#ffffff"
        }
    },
    typography: {
        fontFamily: ["Montserrat", "sans-serif"].join(","),
        fontSize: 12,
        h1: {
            fontFamily: ["Montserrat", "sans-serif"].join(","),
            fontSize: 40,
        },
        h2: {
            fontFamily: ["Montserrat", "sans-serif"].join(","),
            fontSize: 32,
        },
        h3: {
            fontFamily: ["Montserrat", "sans-serif"].join(","),
            fontSize: 24,
        },
        h4: {
            fontFamily: ["Montserrat", "sans-serif"].join(","),
            fontSize: 20,
        },
        h5: {
            fontFamily: ["Montserrat", "sans-serif"].join(","),
            fontSize: 16,
        },
        h6: {
            fontFamily: ["Montserrat", "sans-serif"].join(","),
            fontSize: 14,
        },
    },
};
